import { Fragment, FunctionComponent } from 'react';
import { forEach } from 'es-toolkit/compat';
import { preventBubbleOutside } from '../utils/eventUtils';
import Linkify from 'linkify-react';

interface NewlineEscapedTextProps {
  text: string;
  linkify?: boolean;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
const NewlineEscapedText: FunctionComponent<React.PropsWithChildren<NewlineEscapedTextProps>> = ({
  text,
  linkify,
}) => {
  const lines = text.split('\n');
  const array: JSX.Element[] = [];

  forEach(lines, (line: string, index: number) => {
    const lineKey = `${line}-${index}`;
    array.push(<Fragment key={lineKey}>{line}</Fragment>);

    if (index !== lines.length - 1) {
      const breakKey = `break-${index}`;
      array.push(<br key={breakKey} />);
    }
  });

  return linkify ? (
    <Linkify
      options={{
        attributes: {
          rel: 'noopener noreferrer',
          onClick: preventBubbleOutside,
        },
      }}
    >
      {array}
    </Linkify>
  ) : (
    <>{array}</>
  );
};

export default NewlineEscapedText;
